/* Fet & Silk — Main JS */

document.addEventListener('DOMContentLoaded', function () {

  /* ---- MOBILE NAV ---- */
  const hamburger = document.querySelector('.nav-hamburger');
  const mobileNav = document.querySelector('.mobile-nav');

  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('open');
      document.body.style.overflow = mobileNav.classList.contains('open') ? 'hidden' : '';
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        document.body.style.overflow = '';
      });
    });
  }

  /* ---- CART DRAWER ---- */
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartClose = document.querySelector('.cart-drawer__close');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');

  function openCart() {
    if (cartOverlay) cartOverlay.classList.add('open');
    if (cartDrawer) cartDrawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartOverlay) cartOverlay.classList.remove('open');
    if (cartDrawer) cartDrawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(function (t) { t.addEventListener('click', function (e) { e.preventDefault(); openCart(); }); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  /* ---- ADD TO CART ---- */
  document.querySelectorAll('.btn-add-to-cart, .btn-atc').forEach(function (btn) {
  btn.addEventListener('click', function (e) {
    e.preventDefault();
    const variantId = btn.dataset.variantId || btn.closest('form')?.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    const originalText = btn.textContent;
    btn.textContent = 'Adding...';
    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
    .then(function (r) { return r.json(); })
    .then(function () { return fetch('/cart.js'); })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      document.querySelectorAll('.cart-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });
      const itemsEl = document.querySelector('.cart-drawer__items');
      if (itemsEl) {
        itemsEl.innerHTML = cart.items.map(function (item) {
          return '<div class="cart-item">' +
            '<div class="cart-item__image">' +
            (item.image ? '<img src="' + item.image + '" alt="' + item.title + '">' : '') +
            '</div>' +
            '<div class="cart-item__info">' +
            '<div class="cart-item__name">' + item.product_title + '</div>' +
            '<div class="cart-item__price">' + formatMoney(item.price) + ' × ' + item.quantity + '</div>' +
            '</div>' +
            '</div>';
        }).join('');
      }
      const footer = document.querySelector('.cart-drawer__footer');
      if (footer) {
        footer.style.display = 'block';
        const subtotalEl = footer.querySelector('.cart-subtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      }
      btn.textContent = 'Added ✓';
      setTimeout(function () {
        btn.textContent = originalText;
        btn.disabled = false;
      }, 1000);
      openCart();if (typeof fbq !== 'undefined') {
  fbq('track', 'AddToCart', {
    value: cart.total_price / 100,
    currency: 'NGN'
  });
}
    })
    .catch(function () {
      btn.textContent = originalText;
      btn.disabled = false;
    });
  });
});


  /* ---- REFRESH CART ---- */
  function refreshCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        const countEl = document.querySelector('.cart-count');
        if (countEl) countEl.textContent = cart.item_count;
        const subtotalEl = document.querySelector('.cart-subtotal');
        if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
      });
  }

  function formatMoney(cents) {
    return '₦' + (cents / 100).toLocaleString('en-NG', { minimumFractionDigits: 0 });
  }

  /* ---- ROLE ACCORDIONS (Careers) ---- */
  document.querySelectorAll('.role-card__header').forEach(function (header) {
    header.addEventListener('click', function () {
      const card = header.closest('.role-card');
      const isOpen = card.classList.contains('open');
      document.querySelectorAll('.role-card').forEach(function (c) { c.classList.remove('open'); });
      if (!isOpen) card.classList.add('open');
    });
  });

  /* ---- OCCASION TABS ---- */
  document.querySelectorAll('.occasion-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.occasion-tab').forEach(function (t) { t.classList.remove('active'); });
      tab.classList.add('active');
      const filter = tab.dataset.filter;
      document.querySelectorAll('.product-card[data-occasion]').forEach(function (card) {
        if (!filter || filter === 'all' || card.dataset.occasion.includes(filter)) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  /* ---- JOURNAL CATEGORY FILTER ---- */
  document.querySelectorAll('.journal-cat').forEach(function (cat) {
    cat.addEventListener('click', function () {
      document.querySelectorAll('.journal-cat').forEach(function (c) { c.classList.remove('active'); });
      cat.classList.add('active');
    });
  });

  /* ---- VARIANT SELECTION ---- */
  document.querySelectorAll('.variant-option').forEach(function (opt) {
    opt.addEventListener('click', function () {
      const group = opt.closest('.variant-options');
      group.querySelectorAll('.variant-option').forEach(function (o) { o.classList.remove('selected'); });
      opt.classList.add('selected');
      const hiddenInput = document.querySelector('[name="id"]');
      if (hiddenInput && opt.dataset.variantId) hiddenInput.value = opt.dataset.variantId;
    });
  });

  /* ---- GIFT WRAP BUTTON ---- */
  document.querySelectorAll('.btn-gift-wrap, .btn-gift-note').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const noteSection = document.querySelector('.gift-note-input-section');
      if (noteSection) noteSection.classList.toggle('open');
    });
  });

  /* ---- SMOOTH SCROLL FOR ANCHOR LINKS ---- */
  document.querySelectorAll('a[href^="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      const target = document.querySelector(anchor.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: 'smooth' }); }
    });
  });

});
